// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.panel{
    display: none;
    animation: fadeIn 1s both;
    
}
.showpanel{
    display: grid;
    animation: fadeIn 1s both;

}
.listchange{
    border: none;
    font-size: 15px;
    background-color: transparent;
    color: white;
}
.outeracord{
    padding: 0;
    border: none;
    background-color: #f3eeea ;
    font-size: large;
    padding-left: 8px;
}

@keyframes fadeIn {
    from {
        transform: translateX(-100%); /* Start from outside the left edge */
      }
      to {
        transform: translateX(0); /* Move to its original position */
      }
    
  }`, "",{"version":3,"sources":["webpack://./src/Components/admin/admin.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,yBAAyB;;AAE7B;AACA;IACI,aAAa;IACb,yBAAyB;;AAE7B;AACA;IACI,YAAY;IACZ,eAAe;IACf,6BAA6B;IAC7B,YAAY;AAChB;AACA;IACI,UAAU;IACV,YAAY;IACZ,0BAA0B;IAC1B,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI;QACI,4BAA4B,EAAE,qCAAqC;MACrE;MACA;QACE,wBAAwB,EAAE,kCAAkC;MAC9D;;EAEJ","sourcesContent":[".panel{\n    display: none;\n    animation: fadeIn 1s both;\n    \n}\n.showpanel{\n    display: grid;\n    animation: fadeIn 1s both;\n\n}\n.listchange{\n    border: none;\n    font-size: 15px;\n    background-color: transparent;\n    color: white;\n}\n.outeracord{\n    padding: 0;\n    border: none;\n    background-color: #f3eeea ;\n    font-size: large;\n    padding-left: 8px;\n}\n\n@keyframes fadeIn {\n    from {\n        transform: translateX(-100%); /* Start from outside the left edge */\n      }\n      to {\n        transform: translateX(0); /* Move to its original position */\n      }\n    \n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
